<template>
    <base-dialog :loading="loading" :value="dialog" :title="$t('common.create_chat')" :width="440" @input="onInput" @close="hide">
        <div class="form-group">
            <span class="form-label">{{ $tc('coach.coach', 1) }}</span>
            <kimsa-combobox :placeholder="$t('common.select_placeholder')" dense solo with-selected-dot
                :items="coaches" @change="setCoach" :value="coach" item-value="objectID" searchable />
        </div>

        <div class="form-group mt-4">
            <span class="form-label">{{ $t('common.message') }}</span>
            <kimsa-text-field :placeholder="$t('common.write_here')" @change="message = $event" :value="message"
                dense force-value />
        </div>

        <template v-slot:footer>
            <dialog-actions :confirm-label="$t('common.create')" :disabled="!valid" :loading="loading" @cancel="hide"
                @confirm="save" />
        </template>
    </base-dialog>
</template>

<script>
import KimsaTextField from "@/components/common/inputs/KimsaTextField";
import { db, Timestamp } from "@/utils/Firebase";
import { findChat } from "@/utils/Messages";
import KimsaCombobox from '../common/inputs/KimsaCombobox.vue';
import BaseDialog from "@/components/common/BaseDialog";
import DialogActions from "@/components/common/DialogActions";
export default {
    name: "CreateCompanyChatDialog",
    components: { KimsaTextField, KimsaCombobox, BaseDialog, DialogActions },
    props: {
        isSecondDialog: {
            type: Boolean,
            default: false,
        },
        coaches: {
            type: Array,
            default: () => []
        }
    },
    data() {
        return {
            dialog: false,
            loading: false,
            coach: null,
            message: '',
        }
    },
    computed: {
        valid(vm = this) {
            return vm.coach && vm.message
        },
        companyId(vm = this) {
            return vm.currentUser?.uid || null
        },
        coachId(vm = this) {
            return vm.coach?.objectID || null
        }
    },
    methods: {
        show() {
            this.dialog = true
        },
        hide() {
            const vm = this
            vm.dialog = false
            vm.reset()
        },
        onInput(val) {
            if (!val) this.hide()
        },
        reset() {
            const vm = this
            vm.coach = null
            vm.message = ''
        },
        setCoach(coach) {
            const vm = this;
            vm.coach = coach?.name ? coach : vm.coaches?.find(op => op.name?.toLowerCase() === coach?.toLowerCase()) || null
        },
        async isExistsChat() {
            const vm = this;
            return !!(await findChat('privateChats', 'company_coach', vm.companyId, vm.coachId))
        },
        async save() {
            const vm = this
            vm.loading = true

            if (await vm.isExistsChat()) {
                vm.toast(vm.$t('common.already_chat_created'), 'error')
                return vm.loading = false
            }

            let newChatPayload = {
                type: 'company_coach',
                participants: [vm.companyId, vm.coachId]
            }

            let newChat = await db.collection('privateChats').add(newChatPayload)
            const chatId = newChat.id

            let messagePayload = {
                message: vm.message,
                from: vm.companyId,
                read: true,
                timestamp: Timestamp.now(),
                type: 'text',
            }

            await db.collection('privateChats').doc(chatId).collection('messages').add(messagePayload)
            await db.collection('privateChats').doc(chatId).update({ lastMessage: messagePayload })

            vm.loading = false
            vm.hide()
            vm.$emit('success', { chatId, client: vm.coach })
        }
    },
}
</script>

<style scoped>
.form-group {
    display: flex;
    flex-direction: column;
    gap: 6px;
}

.form-label {
    font-size: var(--fs-label);
    font-weight: 500;
    color: var(--v-txtSecondary-base);
}
</style>